 class ModuleParam {
    constructor(){
        this.configPath = "";
        this.json = "";
        this.callback = "";
    }

    setModuleParam(configPath, json, callback){
        if(configPath !== undefined){
            this.configPath = configPath;
        }
        if(json !== undefined){
            this.json = json;
        }
        if(callback !== undefined){
            this.callback = callback;
        }
    }
}
export default (new ModuleParam);